import { IconSvg } from './IconSvg'
import type { IconProps } from './IconSvg'

/** pencil, edit. Decorative line icon; always pair with a visible text label. */
export function EditIcon({ size, className }: IconProps) {
  return (
    <IconSvg size={size} className={className}>
      <path d="M17 3.5a2.8 2.8 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3.5z" />
    </IconSvg>
  )
}
